export default __webpack_public_path__ + "static/media/next-step-dashed-arrow.3f378748.svg";